:host {
  display: block;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

.epds {
  position: relative;
  color: #626469;
  font-size: 0.875rem;
}

@media screen and (max-width: 979px) {
  .epds__collapsible-container {
    padding: 0 16px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

.epds__heading {
  font-size: 1.75rem;
}

@media screen and (max-width: 979px) {
  .epds__heading {
    margin: 20px 0 20px;
    line-height: 25px;
  }
}

.epds .titleContainer {
  color: #626469;
  font-size: 0.875rem;
  margin-top: 5px;
  margin-bottom: 20px;
}

.epds .titleContainer2 {
  color: #626469;
  font-size: 0.875rem;
}

.epds .legend {
  font-size: 0.875rem;
}

.epds .legendMarker, .epds .legendDescription {
  display: inline;
}

.epds .default {
  max-width: 880px;
}

.epds .scrollable {
  display: block;
  overflow: auto;
}

.epds img {
  display: inline;
  border: 0;
  vertical-align: middle;
  padding: 20px;
}

.epds p {
  font-size: 0.875rem;
  margin: 0;
  max-width: 880px;
}

.epds p, .epds .titleContainer2 {
  line-height: 1.25rem;
}

.epds .spacer, .epds .spacer10 {
  height: 5px;
}

.epds span {
  font-size: 0.875rem;
}

.epds table {
  width: 100%;
  -webkit-text-size-adjust: 100%;
  white-space: normal;
  font-size: 0.875rem;
}

.epds table th {
  padding: 0;
  vertical-align: middle;
}

:host(:not([dir="rtl"])) .epds table th {
  text-align: left;
}

:host([dir="rtl"]) .epds table th {
  text-align: right;
}

.epds table th p {
  font-weight: 400;
}

.epds table tr {
  border-bottom: 1px solid #e6e6e6;
}

.epds table tr:last-child {
  border-bottom: none;
}

.epds table tr td {
  vertical-align: top;
  color: #333333;
  vertical-align: middle;
}

:host(:not([dir="rtl"])) .epds table tr td {
  padding: 10px 10px 10px 0;
}

:host([dir="rtl"]) .epds table tr td {
  padding: 10px 0 10px 10px;
}

@media screen and (max-width: 979px) {
  :host(:not([dir="rtl"])) .epds table tr td {
    padding: 0 10px 0 0;
  }

  :host([dir="rtl"]) .epds table tr td {
    padding: 0 0 0 10px;
  }
}

.epds table tr td:first-child {
  width: 35%;
  font-weight: 700;
}

.epds table tr td .emphBold {
  font-weight: 700;
}

.epds table tr td .lockUpperCase:first-letter {
  text-transform: uppercase;
}

.epds table tr td .legend {
  font-weight: bold;
}